var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFootrerBottom = function SvgFootrerBottom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325.334,
    height: 248,
    viewBox: "0 0 325.334 248",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FootrerBottom",
    transform: "translate(-1551.041 -418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Country_side_k696",
    transform: "translate(829.045 216.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M912.233,468.623c.423,22.891-13.038,31.133-29.823,31.443q-.585.011-1.164.008-1.167,0-2.311-.064c-15.169-.793-27.095-8.977-27.488-30.266-.407-22.031,27.237-50.353,29.31-52.447l0,0,.119-.12S911.811,445.735,912.233,468.623Z",
    transform: "translate(-129.446 -50.566)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M948.351,496.593l10.829-15.737L948.355,498.3l0,1.784q-1.167,0-2.311-.064l.775-22.922-.013-.177.02-.034.074-2.166-11.491-17.073L946.906,473.1l.036.458.585-17.318-9.894-17.679,9.955,14.636.28-35.889v-.119l0,.118.366,28.292,9.312-11.391-9.308,13.828.034,15.5,8.618-15.032-8.611,17.31.019,8.617,12.524-20.933-12.519,23.939Z",
    transform: "translate(-196.557 -50.574)",
    fill: "#fc6681"
  })), /*#__PURE__*/React.createElement("g", {
    id: "undraw_winter_magic_5xu2",
    transform: "translate(1320 418)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 4.74,
    cy: 15.098,
    rx: 4.74,
    ry: 15.098,
    transform: "translate(417.737 199.833) rotate(-88.617)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M652.624,346.776c.027,56.572-33.594,76.338-75.077,76.358q-1.445,0-2.877-.031-2.884-.061-5.708-.26c-37.441-2.633-66.541-23.383-66.567-75.994-.026-54.446,69.527-123.191,74.743-128.274,0,0,0,0,.009,0,.2-.194.3-.291.3-.291S652.6,290.209,652.624,346.776Z",
    transform: "translate(-195.269 -175.14)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M653.153,414.482l27.454-38.4L653.086,418.7l-.072,4.407q-2.884-.061-5.708-.26l2.932-56.6-.023-.438.051-.083.279-5.348-27.631-42.691,27.712,38.685.07,1.134,2.215-42.761-23.658-44.117,23.945,36.6,2.285-88.655.009-.3v.29l-.353,69.914,23.512-27.728-23.611,33.749-.6,38.288L676.4,296.039l-22.044,42.383-.335,21.29,31.869-51.161L653.9,367.14Z",
    transform: "translate(-273.614 -175.14)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 1.75,
    cy: 1.75,
    r: 1.75,
    transform: "translate(391.495 69.637)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 1.75,
    cy: 1.75,
    r: 1.75,
    transform: "translate(419.49 165.519)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 1.75,
    cy: 1.75,
    r: 1.75,
    transform: "translate(320.108 178.467)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 3.849,
    cy: 3.849,
    r: 3.849,
    transform: "translate(367.7)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 3.849,
    cy: 3.849,
    r: 3.849,
    transform: "translate(353.352 199.813)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 3.849,
    cy: 3.849,
    r: 3.849,
    transform: "translate(441.536 63.338)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 3.849,
    cy: 3.849,
    r: 3.849,
    transform: "translate(333.056 119.678)",
    fill: "#cfcce0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1793 582.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    transform: "translate(2 1.374)",
    fill: "#68a8c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M82.712,54.537A40.357,40.357,0,1,1,3.364,44.089,41.727,41.727,0,0,0,32.284,55.77a25.061,25.061,0,0,0,8.555-1.37c6.417-2.377,10.963-8.2,14-14.329,1.774-3.619,3.211-7.459,5.588-10.728a21.629,21.629,0,0,1,7.207-6.253A40.273,40.273,0,0,1,82.712,54.537Z",
    transform: "translate(-1.111 -12.85)",
    fill: "#4f84a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M8.435,45.357A40.357,40.357,0,0,1,46.573,5.062Q45.475,5,44.357,5a40.357,40.357,0,1,0,0,80.714q1.118,0,2.217-.062A40.357,40.357,0,0,1,8.435,45.357Z",
    transform: "translate(-2.226 -2.783)",
    fill: "#8a7683",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M126.14,43.357A40.357,40.357,0,0,1,88,83.652q1.1.058,2.216.062A40.357,40.357,0,1,0,90.217,3Q89.1,3,88,3.062a40.357,40.357,0,0,1,38.14,40.295Z",
    transform: "translate(-48.973 -1.67)",
    fill: "#3f5a7c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M41.687,83.375A41.687,41.687,0,1,1,83.375,41.687,41.687,41.687,0,0,1,41.687,83.375Zm0-80.714A39.027,39.027,0,1,0,80.714,41.687,39.027,39.027,0,0,0,41.687,2.661Z",
    transform: "translate(0 0)",
    fill: "#2e576d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M50.31,84.23A34.37,34.37,0,1,1,84.68,49.861,34.37,34.37,0,0,1,50.31,84.23Zm0-67.853A33.483,33.483,0,1,0,83.793,49.861,33.483,33.483,0,0,0,50.31,16.377Z",
    transform: "translate(-8.871 -8.62)",
    fill: "#2e576d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(17.299 55.874) rotate(-0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(17.317 57.772) rotate(-0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(17.336 59.665) rotate(-0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(15.526 53.656) rotate(-0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(15.544 55.554) rotate(-0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(15.563 57.452) rotate(-0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(66.97 24.817)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(1.773 2.23) rotate(-0.55)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(1.791 4.128) rotate(-0.55)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(1.809 6.021) rotate(-0.55)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(0 0.012) rotate(-0.55)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(0.018 1.91) rotate(-0.55)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(0.036 3.803) rotate(-0.55)",
    fill: "#3f5a7c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(64.311 54.089)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(1.773 2.23) rotate(-0.55)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(1.791 4.128) rotate(-0.55)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(1.809 6.021) rotate(-0.55)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(0 0.012) rotate(-0.55)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(0.014 1.91) rotate(-0.55)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(0.032 3.803) rotate(-0.55)",
    fill: "#3f5a7c"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(16.023 24.485) rotate(-56.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(14.969 26.057) rotate(-56.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(13.915 27.633) rotate(-56.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(15.812 21.654) rotate(-56.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 0.631,
    cy: 0.631,
    r: 0.631,
    transform: "translate(14.79 23.303) rotate(-55.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(13.703 24.795) rotate(-56.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(47.38 74.253)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "matrix(0.952, -0.307, 0.307, 0.952, 3.608, 2.742)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "matrix(0.952, -0.307, 0.307, 0.952, 1.802, 3.321)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "matrix(0.952, -0.307, 0.307, 0.952, 0, 3.903)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "matrix(0.952, -0.307, 0.307, 0.952, 5.195, 0.386)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "matrix(0.952, -0.307, 0.307, 0.952, 3.393, 0.968)",
    fill: "#3f5a7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "matrix(0.952, -0.307, 0.307, 0.952, 1.587, 1.547)",
    fill: "#3f5a7c"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(13.063 48.78) rotate(-0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(13.076 50.677) rotate(-0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    transform: "translate(13.094 52.571) rotate(-0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 8.612,
    transform: "translate(7.983 45.807)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 0.647,
    cy: 0.647,
    r: 0.647,
    transform: "translate(16.644 45.16)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 7.149,
    transform: "translate(7.521 44.025)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 0.647,
    cy: 0.647,
    r: 0.647,
    transform: "translate(14.719 43.377)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 4.226,
    transform: "translate(7.521 40.459)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 0.647,
    cy: 0.647,
    r: 0.647,
    transform: "translate(11.797 39.812)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 8.644,
    transform: "translate(7.752 42.242)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 0.647,
    cy: 0.647,
    r: 0.647,
    transform: "translate(16.444 41.594)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 8.612,
    transform: "translate(66.07 45.807)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 0.647,
    cy: 0.647,
    r: 0.647,
    transform: "translate(64.726 45.16)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x1: 7.149,
    transform: "translate(67.995 44.025)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 0.647,
    cy: 0.647,
    r: 0.647,
    transform: "translate(66.651 43.377)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x1: 4.226,
    transform: "translate(70.918 40.459)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 0.647,
    cy: 0.647,
    r: 0.647,
    transform: "translate(69.578 39.812)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 8.644,
    transform: "translate(66.27 42.242)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 0.647,
    cy: 0.647,
    r: 0.647,
    transform: "translate(64.926 41.594)",
    fill: "none",
    stroke: "#2e576d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M76.8,95.866V82.61L63.85,88.282Z",
    transform: "translate(-35.534 -45.974)",
    fill: "#274b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M77.323,61.016V45.45L64.79,66.507Z",
    transform: "translate(-36.057 -25.294)",
    fill: "#274b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M94.93,45.44V61.011l12.71,5.57Z",
    transform: "translate(-52.83 -25.288)",
    fill: "#274b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M94.93,82.61V95.87l12.959-7.584Z",
    transform: "translate(-52.83 -45.974)",
    fill: "#274b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M76.905,119.732V109.07L64.04,101.54Z",
    transform: "translate(-35.639 -56.509)",
    fill: "#274b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M94.93,119.732,107.8,101.54,94.93,109.07Z",
    transform: "translate(-52.83 -56.509)",
    fill: "#274b5b"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFootrerBottom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FootrerBottom.4b68a397.svg";
export { ForwardRef as ReactComponent };